export default "__VITE_ASSET__BiheEz1h__"